import { isNull } from 'lodash';
import { queryEmployee } from '@/api/api';

const state = {
  userId: null,
  name: null,
  tel: null,
  photo: null,
  openOrder: null,
  allowance: null,
  role: null,
  manager: null,
  discountConfig: null,
  addressDefault: {},
  menuSetting: null,
  symbolField: '',
  isAgreeUser: false,
  isAgreeFace: false,
  isShowProtocol: false,
  organizationId: null
};

const mutations = {
  SET_ORGANIZATIONID: (state, organizationId) => {
    state.organizationId = organizationId;
  },
  SET_USERID: (state, userId) => {
    state.userId = userId;
  },
  SET_ACCOUNTID: (state, userId) => {
    state.userId = userId;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_ROLE: (state, role) => {
    state.role = role;
  },
  SET_TEL: (state, tel) => {
    state.tel = tel;
  },
  SET_PHOTO: (state, photo) => {
    state.photo = photo;
  },
  SET_OpenOrder: (state, openOrder) => {
    state.openOrder = openOrder;
  },
  SET_Allowance: (state, allowance) => {
    state.allowance = allowance;
  },
  SET_DISCOUNT: (state, discountRule) => {
    state.discountRule = discountRule;
  },
  SET_MANAGER: (state, manager) => {
    state.manager = manager;
  },
  SET_DiscountConfig: (state, discountConfig) => {
    state.discountConfig = discountConfig;
  },
  SET_ADDRESS_DEFAULT: (state, addressDefault) => {
    state.addressDefault = addressDefault;
  },
  SET_MENU_SETTING: (state, menuSetting) => {
    state.menuSetting = menuSetting;
  },
  SET_SYMBOL: (state, symbol) => {
    state.symbolField = symbol;
  },
  SET_IS_AGREE_USER: (state, isAgreeUser) => {
    state.isAgreeUser = isAgreeUser;
  },
  SET_IS_AGREE_FACE: (state, isAgreeFace) => {
    state.isAgreeFace = isAgreeFace;
  },
  SET_IS_SHOW_PROTOCOL: (state, isShowProtocol) => {
    state.isShowProtocol = isShowProtocol;
  }
};

const actions = {
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      queryEmployee()
        .then((response) => {
          const { code, data } = response;
          console.log('user', data);
          sessionStorage.setItem('personInfo', JSON.stringify(data));
          if (code === 0) {
            const {
              id,
              role,
              name,
              tel,
              photo,
              allowance,
              discountRule,
              organization: { openOrder, systemSetting },
              classManager,
              departmentManager,
              discountConfig,
              organizationId
            } = data;
            commit('SET_USERID', id);
            commit('SET_ROLE', role);
            commit('SET_ACCOUNTID', id);
            commit('SET_NAME', name);
            commit('SET_TEL', tel);
            commit('SET_PHOTO', photo);
            commit('SET_OpenOrder', openOrder);
            commit('SET_Allowance', allowance);
            commit('SET_DISCOUNT', discountRule);
            commit('SET_ORGANIZATIONID', organizationId);

            commit(
              'SET_IS_SHOW_PROTOCOL',
              !data.userAuths.some(
                (item) => item.channel === 0 && item.type === 0
              ) ||
                (!data.userAuths.some(
                  (item) => item.channel === 0 && item.type === 1
                ) &&
                  photo !== '')
            );

            if (role === 1) {
              if (!isNull(classManager)) commit('SET_MANAGER', classManager.id);
            } else {
              if (!isNull(departmentManager)) {
                commit('SET_MANAGER', departmentManager.id);
              }
            }
            commit('SET_DiscountConfig', discountConfig);
            let menuSetting = JSON.parse(data.organization.menuSetting || '[]');

            menuSetting = menuSetting.filter(
              (item) => item.name === 'SchoolSetting'
            );
            console.log('menuSetting', menuSetting);

            menuSetting[0].children.forEach((item) => {
              if (item.children && item.children.length > 0) {
                item.children.forEach((child) => {
                  child.name = child.name.split('H5')[0];
                  console.log(child.name, 'name');
                });
              }
            });
            commit('SET_MENU_SETTING', menuSetting[0]);
            commit(
              'SET_SYMBOL',
              JSON.parse(systemSetting)?.symbol?.flag ? '积分' : '补助'
            );
            resolve(data);
          } else {
            reject('获取用户信息失败!');
          }
          console.log(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
